export default __webpack_public_path__ + "static/Graphite_sky-4f03431f422c7af7cee2fb75d8105b0d.png";